import { WeekdayHelper } from '@biteinc/enums';
import { Time } from '@biteinc/helpers';
/**
 * @param dayTimestamp [0, 86400000]
 */
export function displayDayTimestamp(dayTimestamp) {
    // Timezone is irrelevant since we're only displaying the day timestamp which already has the
    // offset baked in, so if we did provide a timezone we would be applying the offset twice
    return Time.utc(dayTimestamp).format(dayTimestamp % Time.HOUR ? 'h:mma' : 'ha');
}
function displayDayTimestampFromScheduleBoundary(scheduleBoundary) {
    const dayTimestamp = Time.dayTimestampFromScheduleBoundary(scheduleBoundary);
    return displayDayTimestamp(dayTimestamp);
}
export function dayPartSummary(dayPartData) {
    const dayTimeRanges = WeekdayHelper.allDaysStartingWithMonday()
        .filter((day) => {
        return !!dayPartData[day];
    })
        .map((day) => {
        return {
            day,
            ...dayPartData[day],
        };
    });
    return Time.dayTimeRangeSummary(dayTimeRanges.map(({ day, to, from }) => {
        return {
            day,
            ranges: [{ from, to }],
        };
    }));
}
export function openHoursTimetableSummary(daySchedules) {
    const dayRanges = daySchedules.map(({ weekday, schedules }) => {
        return {
            day: weekday,
            ranges: schedules.map((schedule) => {
                return Time.hourRangeFromSchedule(schedule);
            }),
        };
    });
    return Time.dayTimeRangeSummary(dayRanges);
}
export function displayDayPartData(dayPartData) {
    return `${dayPartData.name}:\n${dayPartSummary(dayPartData).join('\n')}`;
}
export function displayOpenHoursTimetableData(openHoursTimetableData) {
    return `${openHoursTimetableData.posId}:\n${openHoursTimetableSummary(openHoursTimetableData.daySchedules).join('\n')}`;
}
export function openHoursOverrideSummary(openHoursOverride, timezone) {
    const { isOpen, date } = openHoursOverride;
    const { from, to } = openHoursOverride.schedule;
    return [
        `${isOpen ? 'Open' : 'Closed'} on ${Time.moment(date, timezone).format('MM/DD')}`,
        `From ${displayDayTimestampFromScheduleBoundary(from)}` +
            ` to ${displayDayTimestampFromScheduleBoundary(to)}`,
    ].join('\n');
}
export function displayOpenHoursOverrideData(openHoursOverride, timezone) {
    return [
        `${openHoursOverride.posId}:`,
        openHoursOverrideSummary(openHoursOverride, timezone),
    ].join('\n');
}
//# sourceMappingURL=day_part_helper.js.map